module.exports={author:"KB",date:"12/07/2021",publishDate:"12/07/2021",highlighted:!1,badge:"",tags:"",title:"Subject Line: Updates from KB"};